<template>
  <div class="text-center video-player">
    <vue-vimeo-player v-if="video.vimeo_id" :video-id="video.vimeo_id"
                      player-height="360" :options="{byline: false}"
                      @play="play"/>
    <!--    <iframe v-if="video.vimeo_id" style="width: 100%" @play="$emit('play')"-->
    <!--            :src="`https://player.vimeo.com/video/${video.vimeo_id}?byline=0&portrait=0`"-->
    <!--            width="1280" height="360" frameborder="0" allow="autoplay; fullscreen"-->
    <!--            allowfullscreen></iframe>-->
    <video v-else
           :src="video.url"
           controls
           @play="play"
    ></video>
  </div>
</template>

<script>
import {vueVimeoPlayer} from 'vue-vimeo-player'

export default {
  name: "VideoPlayer",
  components: {vueVimeoPlayer},
  props: {video: {type: Object, required: true}},
  methods: {
    play() {
      console.log('play')
      this.$emit('play')
    }
  }
}
</script>

<style lang="scss">
.video-player {

  iframe, video {
    width: 100%;
  }

}
</style>
